const baseStyle = {
  paddingY: 8,
  paddingX: 32
}

export default {
  baseStyle
}
